var map = {
	"./pic_biuro.svg": "d08e",
	"./pic_dom.svg": "ea20",
	"./pic_elektronika.svg": "3d45",
	"./pic_kuchnia.svg": "291c",
	"./pic_lazienka.svg": "8366",
	"./pic_ogrod.svg": "ac04",
	"./pic_ogrzewanie.svg": "9055",
	"./pic_poza-domem.svg": "e379",
	"./pic_transport.svg": "bcb1",
	"./pic_zakupy.svg": "2d2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e17";